var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { approveVolunteersBulkActionType, } from '../../../../../backend/features/shift/shared';
import { ParticipantTable } from '../../../../../ui/components/participant-table';
import { approvalCountToUseAsyncRequest } from '../../../../../ui/features/shift-details/components/shift-pending-table/utils/shiftPendingConstants';
import { ParticipantsAvailabilityContext } from '../../../../../ui/features/shift-details/contexts/ParticipantsAvailabilityContext';
import { useAdminParticipantTableColumns } from '../../../../../ui/features/shift-roster-table/hooks';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { showAlertDialog, showConfirmDialog, showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { Alert, List, ListItem, Typography } from '@mui/material';
import React from 'react';
import { ReviewParticipationsProvider } from '../../contexts/ReviewParticipationsContext';
import { useFormDenyConfig } from '../../hooks/useFormDenyConfig';
import { getPositionCount } from '../../utils/getPositionCount';
import { groupParticipations } from '../../utils/groupParticipations';
import { EmptyTableView } from './components/EmptyTableView';
import { TableRowActions } from './components/TableRowActions';
import { Toolbar } from './components/Toolbar';
import { ReviewParticipationsSection } from './components/review-participations/ReviewParticipationsSection';
export const ShiftPendingTable = ({ pendingRequests, totalRequestNumber, missionStatus, approvedRequests, shiftPositions, reloadShiftsAndParticipants, onHandleDeny, onHandleApprove, onRowClick, onPromoteShift, }) => {
    const formDenyConfig = useFormDenyConfig();
    const [participantsWithLoadingState, setParticipantsWithLoadingState] = React.useState([]);
    const { setLastModifiedShiftParticipants } = React.useContext(ParticipantsAvailabilityContext);
    const { t } = useMissionsTranslation();
    const handleApprove = (shiftId, approveParameters, handleSelectReset) => __awaiter(void 0, void 0, void 0, function* () {
        const participants = approveParameters.map(({ shiftParticipantId }) => shiftParticipantId);
        setParticipantsWithLoadingState((prev) => [...prev, ...participants]);
        yield (onHandleApprove === null || onHandleApprove === void 0 ? void 0 : onHandleApprove({
            shiftId: shiftId,
            shiftParticipations: approveParameters.map((parameter) => ({
                shiftParticipationId: parameter.shiftParticipationId,
                shiftParticipantId: parameter.shiftParticipantId,
                positionId: parameter.positionId,
            })),
        }));
        setParticipantsWithLoadingState((prev) => prev.filter((val) => !participants.includes(val)));
        handleSelectReset(approveParameters.map((parameter) => parameter.rowId));
    });
    const showVolunteerAlreadyAssignedModal = (overlappingParticipations) => {
        showAlertDialog({
            title: t('shifts.pendingRequest.approveShift.volunteerAlreadyAssignedModal.title'),
            closeLabel: t('common.close'),
            content: (React.createElement(React.Fragment, null,
                React.createElement(Typography, { sx: { color: themeColors.text.subtle } }, t('shifts.pendingRequest.approveShift.volunteerAlreadyAssignedModal.description')),
                React.createElement(List, { sx: {
                        color: themeColors.text.subtle,
                        listStyleType: 'disc',
                        listStylePosition: 'inside',
                        py: 2,
                    } }, overlappingParticipations.map((participation) => (React.createElement(ListItem, { sx: { display: 'list-item', py: 0 }, key: participation.id }, participation.columns.participantFullName)))),
                React.createElement(Alert, { severity: 'info' }, t('shifts.pendingRequest.approveShift.volunteerAlreadyAssignedModal.alert')))),
        });
    };
    const handleToolbarApprove = (shiftId, selectedRows, handleSelectReset) => {
        const overlappingParticipations = selectedRows.filter((row) => !row.columns.isParticipantAvailable);
        if (overlappingParticipations.length > 0) {
            showVolunteerAlreadyAssignedModal(overlappingParticipations);
            return;
        }
        const { validParticipations, invalidParticipations } = groupParticipations(selectedRows);
        const validParticipationsCount = validParticipations.length;
        const invalidParticipationsCount = invalidParticipations.length;
        const confirmationDialogContent = (React.createElement(Alert, { severity: 'info', icon: false },
            React.createElement("ul", null,
                React.createElement("li", null,
                    "Ready for approval: ",
                    validParticipationsCount),
                React.createElement("li", null,
                    "Review required: ",
                    invalidParticipationsCount))));
        const handleAfterApproveAll = () => {
            handleSelectReset();
            reloadShiftsAndParticipants();
            setLastModifiedShiftParticipants({
                shiftId,
                shiftStartTime: selectedRows[0].columns.shiftStartTime,
                shiftStopTime: selectedRows[0].columns.shiftStopTime,
                participantIds: selectedRows.map(({ columns }) => columns.participantId),
            });
            showAlertSnackbar({
                message: t('shifts.pendingRequest.approveShift.approvedInfoSnackbar'),
                autoHideDuration: 2000,
                type: 'success',
            });
        };
        const handleAfterDenyAll = () => {
            handleSelectReset();
            reloadShiftsAndParticipants();
            showAlertSnackbar({
                message: t('shifts.pendingRequest.denyShift.denied'),
                autoHideDuration: 2000,
                type: 'success',
            });
        };
        const showReviewParticipationsDialog = () => {
            showCustomDialog({
                maxWidth: 'lg',
                content: (close, ariaTitleId) => {
                    const handleDeny = (row, denialReason) => __awaiter(void 0, void 0, void 0, function* () {
                        yield (onHandleDeny === null || onHandleDeny === void 0 ? void 0 : onHandleDeny({
                            missionId: row.columns.missionId,
                            participationId: row.id,
                            participantId: row.columns.participantId,
                            shiftId: row.columns.shiftId,
                            status: denialReason,
                        }));
                        handleSelectReset([row.id]);
                    });
                    return (React.createElement(ReviewParticipationsProvider, { data: invalidParticipations },
                        React.createElement(ReviewParticipationsSection, { titleId: ariaTitleId, onDenyParticipation: handleDeny, onEmptyParticipations: () => close(undefined), onSkipApproval: () => close(undefined), onBeforeApproveAll: () => close(undefined), onBeforeDenyAll: () => close(undefined), onAfterApproveAll: handleAfterApproveAll, onAfterDenyAll: handleAfterDenyAll })));
                },
            });
        };
        showConfirmDialog({
            title: t('shifts.pendingRequest.approveShift.toolbarApproveConfirmDialogTitle'),
            confirmLabel: t('shifts.pendingRequest.approveShift.toolbarApproveConfirmButtonText'),
            content: confirmationDialogContent,
            onConfirm: () => {
                if (validParticipations.length) {
                    const shiftParticipations = selectedRowsToApproveParticipationParams(validParticipations);
                    launchBulkAction({
                        type: approveVolunteersBulkActionType,
                        title: t('shifts.pendingRequest.approveShift.approvingModalTitle'),
                        autoCloseWhenFinished: true,
                        runSync: shiftParticipations.length < approvalCountToUseAsyncRequest,
                        params: {
                            shiftId,
                            shiftParticipations,
                            totalShiftParticipations: validParticipationsCount,
                        },
                        onClose: () => {
                            handleAfterApproveAll();
                            if (invalidParticipations.length) {
                                showReviewParticipationsDialog();
                            }
                        },
                    });
                }
                else {
                    showReviewParticipationsDialog();
                }
            },
        });
    };
    const handleApproveSingle = (shiftId, selectedRows, handleSelectReset) => __awaiter(void 0, void 0, void 0, function* () {
        const overlappingParticipations = selectedRows.filter((row) => !row.columns.isParticipantAvailable);
        if (overlappingParticipations.length > 0) {
            showVolunteerAlreadyAssignedModal(overlappingParticipations);
            return;
        }
        const [selectedRow] = selectedRows;
        const multiplePositionsRow = selectedRow.columns.positions.length > 1;
        if (multiplePositionsRow) {
            showFormDialog({
                title: t('shifts.pendingRequest.approveShift.singleRowApproveDialogTitle', {
                    fullName: selectedRow.columns.participantFullName,
                }),
                config: {
                    type: 'form',
                    children: [
                        {
                            type: 'form.panel',
                            children: [
                                {
                                    type: 'form.content',
                                    key: 'content',
                                    render: () => {
                                        return (React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle }, t('shifts.pendingRequest.approveShift.singleRowApproveDialogContent')));
                                    },
                                },
                                {
                                    type: 'form.advancedRadio',
                                    key: 'selectParticipationPosition',
                                    values: selectedRow.columns.positions.map((position) => ({
                                        value: position.participationId,
                                        label: position.positionName,
                                        disabled: isPositionFilled(position.positionId),
                                    })),
                                    validate: {
                                        required: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
                onSubmit: (_a) => __awaiter(void 0, [_a], void 0, function* ({ selectParticipationPosition }) {
                    const request = pendingRequests.find((request) => request.columns.positions.some((position) => position.participationId === selectParticipationPosition));
                    const position = request === null || request === void 0 ? void 0 : request.columns.positions.find((position) => position.participationId === selectParticipationPosition);
                    if (request && position) {
                        yield handleApprove(shiftId, [
                            {
                                rowId: request.id,
                                shiftParticipantId: request.columns.participantId,
                                positionId: position.positionId,
                                shiftParticipationId: position.participationId,
                            },
                        ], handleSelectReset);
                    }
                }),
                submitLabel: t('common.approve'),
            });
        }
        else {
            yield handleApprove(shiftId, selectedRowsToApproveParticipationParams(selectedRows), handleSelectReset);
        }
    });
    const handleDenyParticipation = (row, handleSelectReset) => {
        const volunteerFullName = row.columns.participantFullName;
        showFormDialog({
            title: t('shifts.pendingRequest.denyShift.title', { volunteerFullName, count: 1 }),
            config: formDenyConfig,
            onSubmit: (_a) => __awaiter(void 0, [_a], void 0, function* ({ denialReason }) {
                yield (onHandleDeny === null || onHandleDeny === void 0 ? void 0 : onHandleDeny({
                    missionId: row.columns.missionId,
                    participationId: row.id,
                    participantId: row.columns.participantId,
                    shiftId: row.columns.shiftId,
                    status: denialReason,
                }));
                handleSelectReset([row.id]);
            }),
            submitLabel: t('shifts.pendingRequest.denyShift.submitButtonText'),
        });
    };
    const isPositionFilled = (positionId) => {
        var _a, _b;
        const positionQuantity = (_b = (_a = shiftPositions.find((position) => position.id === positionId)) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 0;
        return !(positionQuantity - getPositionCount(approvedRequests, positionId));
    };
    return (React.createElement(ParticipantTable, { allRows: pendingRequests, onRowClick: onRowClick, totalRows: totalRequestNumber, columns: useAdminParticipantTableColumns(), showTableHead: false, showTableBorder: false, showToolbarBorder: false, toolbar: (params) => (React.createElement(Toolbar, { totalRequestsNumber: totalRequestNumber, disableApproveButton: !params.selectedRows.length, multiSelect: params.multiSelect, onApproveVolunteer: () => handleToolbarApprove(params.selectedRows[0].columns.shiftId, params.selectedRows, params.handleSelectReset) })), tableRowActions: (row, handleSelectReset) => (React.createElement(TableRowActions, { participantStatus: row.columns.status, handleApprove: () => handleApproveSingle(row.columns.shiftId, [row], handleSelectReset), handleDeny: () => handleDenyParticipation(row, handleSelectReset), disableActions: participantsWithLoadingState.includes(row.columns.participantId) })), emptyTableView: React.createElement(EmptyTableView, { missionStatus: missionStatus, onPromoteShift: onPromoteShift }) }));
};
function selectedRowsToApproveParticipationParams(selectedRows) {
    return selectedRows.map((row) => ({
        shiftParticipationId: row.id,
        shiftParticipantId: row.columns.participantId,
        positionId: row.columns.positionId,
        rowId: row.id,
    }));
}
